import SupportText from './SupportText';

export default SupportText;
